import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'msTwoDigitConverter',
})
export class TwoDigitConverterPipe implements PipeTransform {
    /**
     * @param  value - The Score value.
     * @returns  - If the Score is single digit for eg. 0,1,2 etc then converts it to two digit with 0 as the prefix -> 00,01,02, etc.
     * If the provided input is a string then we return the same as recieved.
     */

    transform(value?: number | string, shouldAddPrefix = false): string | void {
        if (typeof value === 'undefined') {
            return;
        }

        if (shouldAddPrefix) {
            if (typeof value == 'number') {
                return value.toString().padStart(2, '0');
            }
            return Number(value) > 9 || isNaN(Number(value)) ? value : value.padStart(2, '0');
        }

        return value.toString();
    }
}
